import {Mask} from './Mask';
import {MaskImpl} from './MaskImpl';

export class MaskDateRu extends MaskImpl implements Mask {

    public execute() {
        if (this.target.classList.contains('bb_type_date')) {
            return;
        }
        this.init();
    }

    public normalize(value: string): string {
        if (!value) {
            return value;
        }
        var onlyNums = value.replace(/[^\d]/g, '');
        if (onlyNums.length <= 2) {
            return onlyNums;
        }
        if (onlyNums.length <= 4) {
            return onlyNums.slice(0, 2) + '.' + onlyNums.slice(2);
        }
        return onlyNums.slice(0, 2) + '.' + onlyNums.slice(2, 4) + '.' + onlyNums.slice(4, 8);
    }

}
